var _excluded = ["children"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext, createContext } from "react";
var ImgixContext = /*#__PURE__*/createContext();

/**
 * `useImgixContext()` tries to invoke `React.useContext()`. If no context
 * is available, this function returns `undefined`.
 * @returns The context defined by the closest parent `ImgixProvider`.
 */
function useImgixContext() {
  return useContext(ImgixContext);
}

/**
 * Creates a Provider component that passes `reactImgixProps` as the Context
 * for child components who use the `useImgixContext()` custom hook or
 * `React.useContext()` API.
 * @param {React.Element <typeof Component>} children
 * @param {Object} reactImgixProps
 * @returns React.Element
 */
function ImgixProvider(_ref) {
  var children = _ref.children,
    reactImgixProps = _objectWithoutProperties(_ref, _excluded);
  var value = reactImgixProps;
  if (children == null || children.length < 1) {
    console.error("ImgixProvider must have at least one Imgix child component");
  }
  return /*#__PURE__*/React.createElement(ImgixContext.Provider, {
    value: value
  }, children);
}
export { ImgixProvider, useImgixContext };
//# sourceMappingURL=imgixProvider.js.map